var map = {
	"./IMG_0001.png": 6577,
	"./IMG_0027.JPG": 2074,
	"./IMG_2129.png": 8252,
	"./IMG_2446.JPG": 1351,
	"./IMG_2982.JPG": 2086,
	"./IMG_4145.png": 6332,
	"./IMG_5152.JPG": 2228,
	"./IMG_6890.png": 1161,
	"./IMG_7203.JPG": 2403,
	"./IMG_7999.JPG": 5697,
	"./IMG_9082.JPG": 386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7077;